import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'app-skeleton',
  template: ` <div
    class="skeleton"
    [class.__no-animation]="!animation"
    [style.width]="width"
    [style.height]="height"
    [style.borderRadius]="round"
    [style.top]="top"
    [style.left]="left"
    [style.backgroundColor]="color">
    &nbsp;
  </div>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SkeletonComponent {
  @HostBinding('class') class = 'app-skeleton';
  @Input() animation = true;
  @Input() width = '20px';
  @Input() height?: string;
  @Input() round = '2px';
  @Input() color?: string;
  @Input() top?: string;
  @Input() left?: string;
}
